import React from "react";
import GlobalContext from "./globalContext";
import useSession from "./sessionContext/useSession";
import useLog from "./logContext/useLog";
import usePhotos from "./photosContext/usePhotos";
import useJob from "./jobContext/useJob";
import useCustomer from "./customerContext/useCustomer"

const GlobalState = props => {
  const stateHooks = {
    session: useSession(),
    log: useLog(),
    photos: usePhotos(),
    job: useJob(),
    customer: useCustomer(),
    sessionId: props.sessionId
  };

  return (
    <GlobalContext.Provider value={stateHooks}>
      {props.children}
    </GlobalContext.Provider>
  );
};

export default GlobalState;
